import { fg } from '@atlaskit/platform-feature-flags';
import { sendPackageOperationalEvent } from '../../../common/utils';
import { isProcessingAllowedByPreferences } from '../../../common/utils/item-processing';
import { Logger } from '../../../common/utils/logger';
import { BSCIndexedDB } from '../../../services/indexed-db-service';
import { Status } from '../../../types';
// SET COOKIE ANALOGUE
/**
 * Sets a WebStorage item asynchronously. This queries user preferences before setting
 * the item, so it must be used for any items which are not strictly necessary.
 */
export const setStorageItem = async (itemKey, value, storageType, browserStorage) => {
  // Flag disabled, allow all items.
  if (!fg('platform.moonjelly.browser-storage-controls')) {
    const eventAttributes = {
      wasRejected: false,
      itemKey,
      storageType
    };
    try {
      browserStorage.setItem(itemKey, value);
      return Status.SUCCESS;
    } catch (e) {
      Logger.errorWithOperationalEvent({
        action: 'usedAtlBrowserStorageSetItemError',
        attributes: eventAttributes,
        message: `Failed to set ${storageType} item. ${e.message || ''}`
      });
      return Status.FAILED;
    }
  }

  // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
  const shouldSetItem = await isProcessingAllowedByPreferences({
    itemKey
  });
  const eventAttributes = {
    wasRejected: !shouldSetItem,
    itemKey,
    storageType
  };
  try {
    sendPackageOperationalEvent({
      action: 'usedAtlBrowserStorageSetItem',
      attributes: eventAttributes
    });
    if (shouldSetItem) {
      // Store the item as a record in our IDB service to track that we've seen it before.
      // That way, when we can confirm/deny that this has been set by our service when we check again.
      // If it fails for some reason, it will be caught before actually setting the item
      await BSCIndexedDB.setRecord(itemKey);
      browserStorage.setItem(itemKey, value);
      return Status.SUCCESS;
    } else {
      return Status.BLOCKED;
    }
  } catch (e) {
    Logger.errorWithOperationalEvent({
      action: 'usedAtlBrowserStorageSetItemError',
      attributes: eventAttributes,
      message: `Failed to set ${storageType} item. ${e.message || ''}`
    });
    return Status.BLOCKED;
  }
};